<script lang="ts" setup>
import { createClient } from "@supabase/supabase-js";
import { onMounted, onUnmounted } from "vue";
import client from "./utils/axios";
import { useUserStore } from "./stores/user";

let supabase = createClient(
  process.env.VUE_APP_SUPABASE_URL || "",
  process.env.VUE_APP_SUPABASE_API_KEY || ""
);

let userStore = useUserStore();

onMounted(() => {
  supabase
    .channel("admin_translations_events")
    .on(
      "postgres_changes",
      {
        event: "*",
        schema: "public",
        table: "Events",
        filter: `table_name=eq.translations_admin`,
      },
      async () => {
        const adminResponse = await client.get("/admin-translations");
        userStore.setAdminTranslation(adminResponse.data || []);
      }
    )
    .subscribe();

  supabase
    .channel("database_translations_events")
    .on(
      "postgres_changes",
      {
        event: "*",
        schema: "public",
        table: "Events",
        filter: `table_name=eq.translations_database`,
      },
      async () => {
        userStore.setDatabaseTranslationsUpdateTimestamp();
      }
    )
    .subscribe();
});

onUnmounted(() => {
  supabase.removeAllChannels();
});

onMounted(async () => {
  if (userStore) {
    if (userStore.accessToken) {
      const adminResponse = await client.get("/admin-translations");
      userStore.setAdminTranslation(adminResponse.data || []);
    }
  }
});
</script>

<template>
  <router-view />
</template>
